import { setCookie, hasCookie, getCookie, deleteCookie } from 'common-js/cooke-util';
import { getProductHtml } from '../../desktop/js/modules/home-product-module';

const pageContext = $('meta[name=context-path]').attr('content');
const CSRF = $('meta[name="csrf-token"]').attr('content');
const userId = $("meta[name='user-id']").attr('content');
const PRODUCT_ID = $("#js--product-id").val();

//Init Tooltip manually with custom data-type
$(function() {
    $('[data-toggle="tooltip"]').each(function() {
        var options = {
            html: true,
            trigger: 'manual'
        }

        if ($(this)[0].hasAttribute('data-type')) {
            options['template'] = `
                    <div class="tooltip ${$(this).attr(
                        'data-type'
                    )}" role="tooltip">
                        <div class="arrow"></div>
                        <div class="tooltip-inner"></div>
                    </div>
                `
        }

        $(this).tooltip(options)
    })
})

// Review popup model show
function reviewPopup() {
    if ($('#js--review-popup').length) {
      $('#js--review-popup').fadeIn();
      $('.overlay').show();
    }
}

function lastOrderPopup() {
  $('#js--rating-popup').fadeIn();
  $('.overlay-rating').show();
}

// Entry popup model show
function entryPopup() {
    if ($('#js--entry-popup').length) {
      $('#js--entry-popup').fadeIn();
      $('.overlay').show();
    }
}

//Hide All Popup Modal
$('.js--popup-modal__close-btn').on('click', () => {
    $('.js--popup-modal__close-btn').parent().parent().fadeOut();
    $('.overlay').hide();
});

//Hide Last Order Review Popup Modal
$('#js--review-popup .js--popup-modal__close-btn').on('click', () => {
    $('#js--review-popup').fadeOut();
    $('.overlay').hide();
});

// Similar product popup show
function productPopup() {
    if ($('#js--entry-popup').length) {
        $('#js--entry-popup').fadeIn();
        $('.overlay').show();
    }
}

$('.js--rating-modal__close-btn').on('click', () => {
    $('.js--rating-modal__close-btn').parent().parent().fadeOut();
    $('.overlay-rating').hide();
});

$('#js--rating-popup').click((e) => {
    e.stopPropagation();
});

$('#js--submit-feedback').on('submit', () => {
    $('.js--rating-popup').remove();
    return false;
});

$('#js--review-popup').click((e) => {
    e.stopPropagation();
});

$(document).on('click', 'html, body', event => {
    if (($(event.target).is('img') && $(event.target).parent().is('a')) || ($(event.target).closest('.popup-modal').is('#js--notification-permission-modal') && !$(event.target).closest('button').is('#js--notification-btn-close')) || ($(event.target).hasClass("lookInsideImg") || $(event.target).hasClass("pagesArea") || $(event.target).hasClass("lookInsideDiv"))) {
        return;
    }
    $('.popup-modal').fadeOut();
    $('.rating-modal').fadeOut();
    $('.review-modal').fadeOut();
    $('.similar-product-modal').fadeOut();
    $('.preorder-error-modal').fadeOut();
    $('.overlay').hide();
    $('.overlay-rating').hide();
    $('.overlay-confirmation').hide();
    $('#js--notify-overlay').hide();
});

//Close all Message
$('.close').on('click', function () { $(this).parent().fadeOut() });

// Country Code Dropdown Section

const countryArray = [];
const countryFlagArray = [];

$('#phone-code option').each(function() {
    const img = $(this).attr('data-thumbnail');
    const text = this.innerText;
    const value = $(this).val();
    const item = '<li><img src="'+ img +'" alt="'+value+' icon" value="'+value+'"/><span>'+ text +'</span></li>';
    const item2 = '<img src="'+ img +'" alt="'+value+' icon" value="'+value+'"/> <span class="ion-chevron-down align-middle text-secondary ml-1"></span>';
    countryArray.push(item);
    countryFlagArray.push(item2);
});

// Common implementaions

const applicationProperties = require('../../../applicationProperties.json');
const IMG_FILE_PATH = applicationProperties.imgFilePath;

$('#js--country-item').html(countryArray);
$('.js--btn-select').attr('value', 'BD');

$('#js--country-item li').click(function() {
    const img = $(this).find('img').attr('src');
    const value = $(this).find('img').attr('value');
    const text = this.innerText;
    const item = '<img src="'+ img +'" alt="'+value+' icon" value="'+value+' icon"/> <span class="ion-chevron-down align-middle text-secondary ml-1"></span>';
    $('.js--btn-select').html(item);
    $('.js--btn-select').attr('value', value);
    $('#js--country-dropdown').toggle();
    $('#phone-code option').each(function(i, countryCode) {
        $(countryCode).prop('selected', false);
        if ($(countryCode).val() === value) {
            $(countryCode).prop('selected', true);
            $('.js--code').val('+' + $(countryCode).attr('data-country-code'));
        }
    });
});

$('.js--btn-select').click(function() {
    $('#js--country-dropdown').toggle();
});

// Email/Phone implementaions

$('#js--login-country-item').html(countryArray);
$('.js--login-btn-select').attr('value', 'BD');

$('#js--login-country-item li').click(function() {
    const img = $(this).find('img').attr('src');
    const value = $(this).find('img').attr('value');
    const text = this.innerText;
    const item = '<img src="'+ img +'" alt="'+value+' icon" value="'+value+'"/> <span class="ion-chevron-down align-middle text-secondary ml-1"></span>';
    $('.js--login-btn-select').html(item);
    $('.js--login-btn-select').attr('value', value);
    $('#js--login-country-dropdown').toggle();
    $('#phone-code option').each(function(i, countryCode) {
        $(countryCode).prop('selected', false);
        if ($(countryCode).val() === value) {
            $(countryCode).prop('selected', true);
            $('.js--login-code').val('+' + $(countryCode).attr('data-country-code'));
        }
    });
});

$('.js--login-btn-select').click(function() {
    $('#js--login-country-dropdown').toggle();
});

$('.js--login-username').on('change keyup', function() {
    if ($(this).val().match(/^\d+$/) !== null) {
        $('.js--login-btn-select').parent().removeClass('d-none');
        $('.js--login-code').removeClass('d-none');
        $('.js--login-icon').attr('src', `${IMG_FILE_PATH}/icon-phone.png`);
    } else {
        $('.js--login-btn-select').parent().addClass('d-none');
        $('.js--login-code').addClass('d-none');
        $('.js--login-icon').attr('src', `${IMG_FILE_PATH}/icon-email.png`);
    }
});

// Login Popup implementaions

$('.js--popup-phone-code option').each(function() {
    const img = $(this).attr('data-thumbnail');
    const text = this.innerText;
    const value = $(this).val();
    const item = '<li><img src="'+ img +'" alt="'+value+' flag icon" value="'+value+'"/><span>'+ text +'</span></li>';
    const item2 = '<img src="'+ img +'" alt="'+value+' flag icon" value="'+value+'"/> <span class="ion-chevron-down align-middle text-secondary ml-1"></span>';
    countryArray.push(item);
    countryFlagArray.push(item2);
});

$('.js--popup-login-country-item').html(countryArray);
$('.js--popup-login-btn-select').attr('value', 'BD');

$('.js--popup-login-country-item li').click(function() {
    const img = $(this).find('img').attr('src');
    const value = $(this).find('img').attr('value');
    const text = this.innerText;
    const item = '<img src="'+ img +'" alt="'+value+' flag icon" value="'+value+'"/> <span class="ion-chevron-down align-middle text-secondary ml-1"></span>';
    $('.js--popup-login-btn-select').html(item);
    $('.js--popup-login-btn-select').attr('value', value);
    $('.js--popup-login-country-dropdown').toggle();
    $('.js--popup-phone-code option').each(function(i, countryCode) {
        $(countryCode).prop('selected', false);
        if ($(countryCode).val() === value) {
            $(countryCode).prop('selected', true);
            $('.js--popup-login-code').val('+' + $(countryCode).attr('data-country-code'));
        }
    });
});

$('.js--popup-login-btn-select').click(function() {
    $('.js--popup-login-country-dropdown').toggle();
});

$('.js--popup-login-username').on('change keyup', function() {
    if ($(this).val().match(/^\d+$/) !== null) {
        $('.js--popup-login-btn-select').parent().removeClass('d-none');
        $('.js--popup-login-code').removeClass('d-none');
        $('.js--popup-login-icon').attr('src', `${IMG_FILE_PATH}/icon-phone.png`);
    } else {
        $('.js--popup-login-btn-select').parent().addClass('d-none');
        $('.js--popup-login-code').addClass('d-none');
        $('.js--popup-login-icon').attr('src', `${IMG_FILE_PATH}/icon-email.png`);
    }
});

$(document).on('click', 'html, body', event => {
    if ($(event.target).closest('.country-select').is('.country-select')) {
        return;
    }
    $('#js--country-dropdown').hide();
    $('#js--login-country-dropdown').hide();
    $('.js--popup-login-country-dropdown').hide();
});

// super deal countdown
export function superDealCountDownTimer() {
    const endDate = $('#js--countdown').data('end-date');
    const targetTime = new Date(endDate).getTime();

    $.get(pageContext + '/currentTime', function(currentTime) {
        if(targetTime){
            let timerInterval = setInterval(function() {
                let remainingTime = parseInt((targetTime - currentTime) / 1000);
                currentTime += 1000;
    
                if(Math.floor(remainingTime) < 0) {
                    clearInterval(timerInterval);
                    return;
                }
    
                let hours = Math.floor(remainingTime / (60 * 60));
                let min = Math.floor((remainingTime % (60 * 60)) / (60));
                let sec = Math.floor(remainingTime % (60));
    
                $('#js--hour-timer').text(hours < 10 ? '0'+hours : hours);
                $('#js--minute-timer').text(min < 10 ? '0'+min : min);
                $('#js--second-timer').text(sec < 10 ? '0'+sec : sec);
            }, 1000);
        }
    });
}

$(() => {
    const regex = /^\/book[;?A-Za-z0-9=]*$/
    if(!regex.test(location.pathname)) {
        superDealCountDownTimer();
    }
})

// rokomari affiliate service
function idBreaker(affiliateLink) {
    const url = new URL(affiliateLink);
    const params = new URLSearchParams(url.search);

    const affURL = affiliateLink;
    const affNanoId = params.get('affId');
    const affNumericId = +params.get('affs');
    const cookieMaxAge = +params.get('cma');
    const assetId = params.has('rokat') ? params.get('rokat') : undefined;
    const productId = params.has('pdi') ? params.get('pdi') : undefined;
    const clickDate = Date.now();

    return {
        affURL,
        affNanoId,
        affNumericId,
        assetId,
        cookieMaxAge,
        clickDate,
        productId,
        isSpecific: params.has('rokat') ? true : false
    }
}

const productType = $('#js--aff-productType').val() || null;

let affBaseURL;
if(location.hostname == "www.rokomari.com") {
    affBaseURL = "https://affiliateback.rokomari.io"
} else if (location.hostname == "www.rokomari.club") {
    affBaseURL = "https://share.rokomari.club"
} else {
    affBaseURL = "http://localhost:4800"
}

$('.js--add-affNumericId').on('click', function() {
    const savedData =  JSON.parse(localStorage.getItem('rokaf')) || false;
    if(savedData) {
        const href = $(this).attr('href');
        $(this).attr('href', `${href}&affNumericId=${savedData.affNumericId}`);
    }
})


if(location.search.startsWith('?affId')) {
    const savedData =  JSON.parse(localStorage.getItem('rokaf'));
    if(savedData) {
        localStorage.removeItem('rokaf');
        const specificCookie = `isSpecific=; max-age=-1`;
        document.cookie = specificCookie;
    }

    const ids = idBreaker(location.href);

    const storageData =  localStorage.setItem('rokaf', JSON.stringify(ids));
    const specificCookie = `isSpecific=${ids.isSpecific}; path=/; max-age=${ids.cookieMaxAge}`
    document.cookie = specificCookie;

    const clickData = {
        isSpecific: ids.isSpecific,
        affiliateNanoId: ids.affNanoId,
        affiliationLink: ids.affURL,
        productType: productType
    }

    $.ajax({
        type: "POST",
        url: affBaseURL + `/click`,
        data: JSON.stringify(clickData),
        contentType: "application/json",
        success: function (response) {}
    });
}

// check if affiliate data already exists in local storage
const savedData =  JSON.parse(localStorage.getItem('rokaf'));
if(savedData && document.cookie.includes(`isSpecific=${savedData.isSpecific}`)) {
    const affLinkFilter = savedData.affURL.split('/').slice(3).join('/');
    document.cookie = `affId=${savedData.affNumericId}; path=/; max-age=${savedData.cookieMaxAge}`;
    document.cookie = `affLnk=${affLinkFilter}; path=/; max-age=${savedData.cookieMaxAge}`;
} else if(!savedData || !document.cookie.includes(`isSpecific=${savedData.isSpecific}`)) {
    localStorage.removeItem('rokaf');
    document.cookie = `isSpecific=; max-age=-1`;
    document.cookie = `affId=; max-age=-1`;
    document.cookie = `affLnk=; max-age=-1`;
}

// Gift finder item selection
$('#js--gift-finder-row a').on('click', function () {
    $('#js--gift-finder-row').css('opacity', '0');
    $('#js--occasion-' + $(this).attr('class')).css('left', '0');
    let whoms = 'Women';
    if ($(this).attr('cat_id') == '2136') {
        whoms = 'Women'
    } else if ($(this).attr('cat_id') == '2137') {
        whoms = 'Men'
    } else if ($(this).attr('cat_id') == '2138') {
        whoms = 'Teens (12-18)'
    } else if ($(this).attr('cat_id') == '2139') {
        whoms = 'Kids (7-12)'
    } else if ($(this).attr('cat_id') == '2140') {
        whoms = 'Kids (3-7)'
    } else if ($(this).attr('cat_id') == '2141') {
        whoms = 'Babies (0-3)'
    }
    $('#js--gift-finder-title').text('To celebrate');
});

//RokX Data Sync
if (hasCookie("needRokxSync")) {
    $.ajax({
        type: "POST",
        url: "/cart/sync_cart_data",
        data: '_tk=' + CSRF,
        success: function (response) {
            $('.js--cart-quantity').text(response);
            deleteCookie("needRokxSync");
            if (hasCookie("cartCookie")) {
                deleteCookie("cartCookie");
            }
        },
        error: function (error) {
            console.log("failed to sync data");
        },
        complete: function () {}
    });
}

document.addEventListener("DOMContentLoaded", function() {
    if (hasCookie("c_nop")) {
        $('.js--cart-quantity').text(getCookie('c_nop'));
    }

    if (hasCookie("cartCookie")) {
        const cartCookieId = +getCookie('cartCookie');
        if(cartCookieId < 1000) {
            deleteCookie('cartCookie');
        }
    }
});

/**
 * See all sub categories buttons
 */
$('#js--common-subcategory-btn-see-more').on('click', function(e) {
    e.preventDefault();
    $(this).hide();
    $('.common-subcategory-list__items .btn-category').fadeIn();
});

// common page specific popup
$(() => {
    if($('#js--page-specific-common-entry-popup').length) {
        let timerInMilliSec = +$('#js--page-specific-common-entry-popup').attr('data-timerInMilliSec');
        let time = JSON.parse(localStorage.getItem('pspop'));
        let currentTime = Date.now();
        
        if(!time || (currentTime > time)) {
            let time = localStorage.setItem('pspop', currentTime + timerInMilliSec);
            $('#js--page-specific-common-overlay').show();
            $('#js--page-specific-common-entry-popup').show();
        }
    }
})

// Online Book Fair 2024 countdown
$(() => {
    if(!hasCookie('entryPopup')) {
        setCookie('entryPopup', true, 0.5);
        entryPopup();
    }
})

// quiz timer countdown
$(() => {
    if ($('#js--quiz-timer').length) {
        const targetDate = new Date();
        const endDate =  targetDate.setHours(23, 59, 59, 999);
        let currentTime =  Date.now();

        let timerInterval = setInterval(function () {
            let remainingTime = parseInt((endDate - currentTime) / 1000);
            currentTime+=1000;

            if (Math.floor(remainingTime) < 0) {
                clearInterval(timerInterval);
                return;
            }

            let hours = Math.floor((remainingTime % (24 * 60 * 60)) / 3600);
            let min = Math.floor((remainingTime % 3600) / 60);
            let sec = Math.floor(remainingTime % 60);
            $('#js--quiz-hour-timer').text(hours < 10 ? '0'+hours : hours);
            $('#js--quiz-minute-timer').text(min < 10 ? '0'+min : min);
            $('#js--quiz-second-timer').text(sec < 10 ? '0'+sec : sec);
            
        }, 1000);
    }
});

// quiz coupon code
function showQuizCouponCode (couponcode) {
              
        $('.js--quiz-copy-code').attr('data-code', couponcode.code);
        $('.js--quiz-code').text(couponcode.code);
        $('.js--quiz-coupon-date').text(couponcode.expireDateMessage);
        $('.js--quiz-coupon-amount-msg').text(couponcode.minimumOrderAmountMessage);

        $('#js--quiz-copon-section').show(); 
}

function copyToClipboardQuizCode(element, text) {
    $("<textarea />").appendTo("body").val(text).select().each(function () {
        document.execCommand('copy');
    }).remove();
    
    element.text('Copied');
}

$(()=>{
    if($('#js--quiz-copon-section').length){
       
        $.ajax({
            url: "/quiz/win-promcode",
            type: "GET",
            success: function(response) {
                if(response.length > 0){
                    showQuizCouponCode(response[0])
                }
            }
        });
    
        $('.js--quiz-copy-code').on('click', function () {
            copyToClipboardQuizCode($(this), $(this).data('code'));
        });
    }
})

$(() => {

  let $menuTooltip = $("#js--menu-tooltip");

  let isAtTop = true;

  $(window).scroll(function() {

    if ($(window).scrollTop() > 0) {
      $menuTooltip.hide();
      isAtTop = false;
    } else {
      if (!isAtTop) {
        $menuTooltip.show();
      }
      isAtTop = true;
    }
  });
});

//user points on menubar
$(document).ready(function () {
    if (userId) {
        $.get('/my-section/my-point', function (response) {
            if (response >= 0) {
                $('.js--user-total-points-container').css('display', 'flex')
                $('#js--user-total-points').text(response);
            }
        })
    }
})

//
// START - Request for Stock
$('.js--special-stock').click(function (event) {
    var quantity = $('#js--details-quantity').val();
    if (quantity === undefined) {
        quantity = '1';
    }
    if (quantity > 5) {
        quantity = '5';
    }
    location.href = pageContext + '/shipping/special?productid=' + PRODUCT_ID + '&qty=' + quantity;
});
// END - Request for Stock


// deep link creator
export function createShortDeeplink(fullUrl, replaceContetId) {
    $.ajax({
        type: 'POST',
        contentType: "application/json",
        url: "https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyBiyajtWLiFEhmCtlGMjMpzlmL9Q-_hW-E",
        data: JSON.stringify({
            dynamicLinkInfo: {
                domainUriPrefix: "https://rokomari.page.link",
                link: fullUrl,

                androidInfo: {
                    androidPackageName: "com.rokomari",
                    androidMinPackageVersionCode: "247"
                },
                
                iosInfo: {
                    iosBundleId: "com.rokomari.rokomariios",
                    iosAppStoreId: "1493045502"
                },

                navigationInfo: {
                    enableForcedRedirect: 1,
                },
            }
        }),

        success: function (response) {
            if (response) {
                $(replaceContetId).attr("href", response.shortLink)
            }
        },

        error: function (error) {
            console.log(error);
        }
    });
}

// create deep link for open app
$(function(){
    if($('.js--open-app-deeplink-url').length){
        const fullUrl = document.URL;
        createShortDeeplink(fullUrl, '.js--open-app-deeplink-url');
    }
})

$(function (){

    if($('#js--user-recommendation-modal'.length)){

       const isShowModal = localStorage.getItem('_urev');
       function closeModal (){
            $('#js--user-recommendation-modal').hide("slow");
            $('#js--recommendation-overlay').hide();
       }
       function showModal (){
            $('#js--user-recommendation-modal').show();
            $('#js--recommendation-overlay').show();
       }

       if(!isShowModal){
            
            setTimeout(() => {
                showModal();
            }, 5000);

            $('.js--rating-button').on('click', function(){
                $('.js--rating-button').removeClass('selected');
                $(this).addClass('selected');
                $('#js--submit-recommendation').removeAttr('disabled')
            });

            $('#js--submit-recommendation').on('click', function(){
                const rating = $('.selected').data('value');
                const comment = $('#js--comment').val();
            
                $.ajax({
                    type: 'POST',
                    url: '/google-sheet/save/recommended-feedback',
                    data: `ratting=${rating}&comments=${comment}&_tk=${CSRF}`,
                    success: function(response){
                        $('#js--submit-form').hide();
                        $('#js--congress-message').show();
                        localStorage.setItem('_urev', true);

                        setTimeout(() => {
                            closeModal()
                        }, 2000);
                    },
                    error: function (error) {}
                });
            
            });

       }

       $('#js--recommendation-overlay').on('click', function(){
            closeModal()
       })

       $('#js--recommendation-close-btn').on('click', function(){
            closeModal()
       })

    }
})

